import { Component } from '@angular/core';
import { TenantConfigService } from 'src/app/shared/services/tenant-config.service';

@Component({
  selector: 'app-simple-footer',
  templateUrl: './simple-footer.component.html',
  styleUrls: ['./simple-footer.component.scss']
})
export class SimpleFooterComponent {
  currentYear: number = new Date().getFullYear();
  companyName: string = '';
  logoUrl: string = '';

  constructor(private tenantConfigService: TenantConfigService) {
    this.companyName = localStorage.getItem('currentLang') === 'ar' && this.tenantConfigService.tenant.companyNameAr ? this.tenantConfigService.tenant.companyNameAr : this.tenantConfigService.tenant.companyName;
    this.logoUrl = this.tenantConfigService.tenant.coloredLogoUrl;
  }
}
